import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link, withRouter} from 'react-router-dom';
import { toast } from "react-toastify";
import UserAvatar from 'react-user-avatar';
import * as apiConfig from "../../api/config";
import PostForm from "./PostForm";
import CommentFeedControl from "./CommentFeedControl";
import BodyParser from "./BodyParser";
import SubjectDataParser from "./SubjectDataParser";
import { loadPostComments, addComment, deleteComment, editComment, deletePost, editPost, deletePostImage, deleteCommentImage, react, unReact } from "../../redux/actions/postCommentActions";
import Spinner from "../common/Spinner";
import Reaction from "../common/Reaction"
import moment from "moment"
import 'bootstrap/js/dist/carousel.js';
import $ from 'jquery';

function PostControl({
    user,
    post,
    active,
    headless,
    expandComments,
    onPostEdited,
    onPostDeleted,
    loadPostComments,
    editPost,
    deletePost,
    addComment,
    editComment,
    deleteComment,
    deletePostImage,
    deleteCommentImage,
    react,
    unReact,
    onCommentCountChanged,
    history
}) {

    const [comments, setComments] = useState(null);
    const [commentDetails, setCommentDetails] = useState({ body: "", images: [], postId: post.id });
    const [postDetails, setPostDetails] = useState({ body: "" });
    const [commentReplyDetails, setCommentReplyDetails] = useState({ body: "", images: [], postId: post.id, parentId: null, });
    const [commentsVisible, setCommentsVisible] = useState(false); 
    const [errors, setErrors] = useState({});
    const [processing, setProcessing] = useState(false);

    useEffect(() => {
        if (expandComments) {
            loadComments();
        }
        setPostDetails(post);
    }, [post]);

    function loadCommentsPanel(e) {
        e.preventDefault();
        loadComments();
    }

    function loadComments() {
        if (commentsVisible) {
            $(`#comments-${post.id}`).collapse('hide');
            setCommentsVisible(false);
            return;
        }
        if (comments != null) {
            $(`#comments-${post.id}`).collapse('show');
            setCommentsVisible(true);
            return;
        }

        var safePost = JSON.parse(JSON.stringify(post))
        safePost.subjectData = null;
        safePost.userReactions = null;

        setProcessing(true);
        loadPostComments(safePost)
            .then((comments) => {
                setComments(comments);
                setProcessing(false);
                setCommentsVisible(true);
                setTimeout(500); 
                $(`#comments-${post.id}`).collapse('show');
            })
    }

    function onCommentChange(e) {
        var { name, value } = e.target;
        setCommentDetails(prevCommentDetails => ({
            ...prevCommentDetails,
            [name]: value
        }));
    }

    function onCommentSave(e) {
        e.preventDefault();
        const errors = {};

        setProcessing(true);

        if (!commentDetails.body) {
            errors.name = "Please enter something!";
            setErrors(errors);
            return;
        }

        var newComment = { body: commentDetails.body, images: commentDetails.images };

        newComment.postId = post.id;
        newComment.authorId = user.id;
        newComment.authorFirstName = user.firstName;
        newComment.authorSurname = user.surname;
        newComment.authorHasAvatar = user.avatarAvailable;
        newComment.replies = [];
        newComment.postedOn = new Date();

        setCommentDetails(prevCommentDetails => ({
            ...prevCommentDetails,
            body: "",
            images: []

        }));

        addComment(newComment)
            .then((commentSaveDetails) => {
                newComment.id = commentSaveDetails.id;
                newComment.images = commentSaveDetails.images;

                var refreshedComments = []
                comments.map(c => {
                    refreshedComments.push(c);
                })
                refreshedComments.push(newComment);
                setComments(refreshedComments);
                
                post.commentCount++;
                if (onCommentCountChanged) { onCommentCountChanged(post.commentCount) };
                setProcessing(false);

            }).catch(error => {
                setCommentDetails(prevCommentDetails => ({
                    ...prevCommentDetails,
                    body: newComment.body,
                    images: newComment.images

                }));
                setProcessing(false);
                setErrors({ onSave: error.message });
                toast.error(`Failed to edit comment: ${error.message}`);
            });
    }

    function handleCommentReplyAdded(reply){
        var refreshedComments = [];

        comments.map(c => {
            refreshedComments.push(c);
        })
        refreshedComments.push(reply);
        setComments(refreshedComments);
                
        post.commentCount++;
        if (onCommentCountChanged) { onCommentCountChanged(post.commentCount) };
    }

    function handleReplyToComment(comment) {
        setCommentReplyDetails(prevCommentReplyDetails => ({
            ...prevCommentReplyDetails,
            postId: comment.postId,
            parentId: comment.id
        }));

        if (headless) {
            $(`#comment-feed-mask-${post.id}`).show();
        }
        $(`#commentReply-${comment.postId}`).modal("show");
    }

    function onCloseCommentReplyModal(e) {
        e.preventDefault();
        if (headless) {
            $(`#comment-feed-mask-${post.id}`).hide();
        }
        $(`#commentReply-${post.id}`).modal("hide");
    }

    function onCommentReplyChange(e) {
        var { name, value } = e.target;
        setCommentReplyDetails(prevCommentReplyDetails => ({
            ...prevCommentReplyDetails,
            [name]: value
        }));
    }

    function onCommentReplySave(e) {
        e.preventDefault();
        const errors = {};

        setProcessing(true);
        if (headless) {
            $(`#comment-feed-mask-${post.id}`).hide();
        }
        $(`#commentReply-${post.id}`).modal("hide");

        if (!commentReplyDetails.body) {
            errors.name = "Please enter something!";
            setErrors(errors);
            return;
        }

        var newCommentReply = { body: commentReplyDetails.body, images: commentReplyDetails.images, postId: commentReplyDetails.postId, parentId: commentReplyDetails.parentId };

        newCommentReply.authorId = user.id;
        newCommentReply.authorFirstName = user.firstName;
        newCommentReply.authorSurname = user.surname;
        newCommentReply.authorHasAvatar = user.avatarAvailable;
        newCommentReply.replies = [];
        newCommentReply.postedOn = new Date();

        addComment(newCommentReply)
            .then((commentSaveDetails) => {
                newCommentReply.id = commentSaveDetails.id;
                newCommentReply.images = commentSaveDetails.images;

                var refreshedComments = [];

                comments.map(c => {
                    if (c.id == newCommentReply.parentId) {
                        c.replies.push(newCommentReply)
                    }
                    refreshedComments.push(c);
                })
                setComments(refreshedComments);

                post.commentCount++;
                if (onCommentCountChanged) { onCommentCountChanged(post.commentCount) };

                setCommentReplyDetails(prevCommentReplyDetails => ({
                    ...prevCommentReplyDetails,
                    body: "",
                    images: []
                }));
                setProcessing(false);

            }).catch(error => {
                setProcessing(false);
                setErrors({ onSave: error.message });
                toast.error(`Failed to edit comment: ${error.message}`);
            });


    }

    function handleEditComment(comment) {
        setProcessing(true);
        editComment(comment)
            .then((savedComment) => {
                var refreshedComments = [];
                comment.images = savedComment.images;
                comments.map(c => {
                    if (c.id == comment.id) {
                        refreshedComments.push(comment)
                    }
                    else {
                        refreshedComments.push(c)
                    }
                })
                setComments(refreshedComments);
                setProcessing(false);
                toast.success(`Comment Updated`);
            })
            .catch(error => {
                setProcessing(false);
                toast.error(`Failed to edit comment: ${error.message}`);
            });
    }

    function handleEditCommentReply(comment) {
        setProcessing(true);
        editComment(comment)
            .then((savedComment) => {
                comment.images = savedComment.images;
                var refreshedComments = [];
                comments.map(c => {
                    var refreshedReplies = [];
                    c.replies.map(r => {
                        if (r.id == comment.id) {
                            refreshedReplies.push(comment)
                        }
                        else {
                            refreshedReplies.push(r)
                        }
                    })
                    c.replies = refreshedReplies;
                    refreshedComments.push(c);
                })
                setComments(refreshedComments);
                setProcessing(false);
                toast.success(`Reply Updated`);
            })
            .catch(error => {
                setProcessing(false);
                toast.error(`Failed to edit comment: ${error.message}`);
            });
    }

    function handleDeleteCommentReply(reply) {
        setProcessing(true);
        deleteComment(reply)
            .then(() => {
                var refreshedComments = [];
                comments.map(c => {
                    var refreshedReplies = [];
                    c.replies.map(r => {
                        if (r.id != reply.id) {
                            refreshedReplies.push(r)
                        }
                    })
                    c.replies = refreshedReplies; 
                    refreshedComments.push(c);
                })
                setComments(refreshedComments);
                post.commentCount--;
                if (onCommentCountChanged) { onCommentCountChanged(post.commentCount) };
                setProcessing(false);
                toast.success(`Reply Deleted`);
            })
            .catch(error => {
                setProcessing(false);
                toast.error(`Failed to delete reply: ${error.message}`);
            });
    }

    function handleDeleteComment(comment) {
        setProcessing(true);
        deleteComment(comment)
            .then(() => {
                var deletedItemCount = comment.replies.length + 1; 
                var refreshedComments = [];
                comments.map(c => {
                    if (c.id != comment.id) {
                        refreshedComments.push(c)
                    }
                })
                setComments(refreshedComments);
                post.commentCount -= deletedItemCount;
                if (onCommentCountChanged) { onCommentCountChanged(post.commentCount) };
                setProcessing(false);
                toast.success(`Comment Deleted`);
            })
            .catch(error => {
                setProcessing(false);
                toast.error(`Failed to delete comment: ${error.message}`);
            });
    }

    function onEditPost(e) {
        e.preventDefault();
        setPostDetails(post);
        $(`#editPost-${post.id}`).modal("show");
    }

    function onPostEditChange(e){
        var { name, value } = e.target;
        setPostDetails(prevPostDetails => ({
            ...prevPostDetails,
            [name]: value
        }));
    }

    function handleEditPostImagesChange(images) {
        setPostDetails(prevPostDetails => ({
            ...prevPostDetails,
            images: images
        }));
    }

  
    function handleReplyImagesChange(images) {
        setCommentReplyDetails(prevCommentReplyDetails => ({
            ...prevCommentReplyDetails,
            images: images
        }));
    }

    function handleCommentImagesChange(images) {
        setCommentDetails(prevCommentDetails => ({
            ...prevCommentDetails,
            images: images
        }));
    }

    function handleEditPost(e) {
        e.preventDefault();
        setProcessing(true);

        var editedPost = JSON.parse(JSON.stringify(postDetails)); 
        editedPost.userReactions.users = [];

        $(`#editPost-${post.id}`).modal("hide");
        editPost(editedPost)
            .then((saveDetails) => {
                setProcessing(false);
                postDetails.images = saveDetails.images;
                toast.success(`Post Updated`);
                onPostEdited(postDetails);
            })
            .catch(error => {
                setProcessing(false);
                toast.error(`Failed to edit post: ${error.message}`);
            });
    }

    function onDeletePost(e) {
        e.preventDefault();
        $(`#confirmDeletePost-${post.id}`).modal("show");
    }

    function handleDeletePost(e) {
        e.preventDefault();
        setProcessing(true);

        var deletedPost = JSON.parse(JSON.stringify(postDetails));
        deletedPost.userReactions.users = [];
        deletedPost.subjectData = null;

        $(`#confirmDeletePost-${post.id}`).modal("hide");
        deletePost(deletedPost)
            .then(() => {
                setProcessing(false);
                toast.success(`Post Deleted`);
                onPostDeleted(post);
            })
            .catch(error => {
                setProcessing(false);
                toast.error(`Failed to delete post: ${error.message}`);
            });
    }

    function openLightbox(index) {
        $(`#post-lightbox-${post.id}`).modal("show");
        $(`#post-carousel-lightbox-${post.id}`).carousel(index);
    }

    function onDeleteImage(e) {
        e.preventDefault();
        $(`#post-lightbox-${post.id}`).modal("hide");
        $(`#confirmDeleteImage-${post.id}`).modal("show");
    }

    function onCancelDeleteImage(e) {
        e.preventDefault();
        $(`#post-lightbox-${post.id}`).modal("show");
        $(`#confirmDeletePost-${post.id}`).modal("hide");
    }

    function handleDeleteImage(e) {
        e.preventDefault();
        var imageIndex = 0

        if (post.images.length > 1) {
            imageIndex = $(`#post-carousel-lightbox-${post.id} .carousel-inner .active`).index(`#post-carousel-lightbox-${post.id} .carousel-inner .carousel-item`);
        }

        setProcessing(true);
        $(`#confirmDeleteImage-${post.id}`).modal("hide");

        deletePostImage(post.id, post.images[imageIndex].fileName)
            .then(() => {
                post.images.splice(imageIndex, 1);
                setProcessing(false);
                toast.success(`Image Deleted`);
            })
            .catch(error => {
                setProcessing(false);
                toast.error(`Failed to delete image: ${error.message}`);
            });
    }

    function handleDeleteCommentImage(commentId, fileName) {
        setProcessing(true);
        deleteCommentImage(commentId, fileName)
            .then(() => {

                var refreshedComments = [];
                comments.map((c) => {
                    if (c.id == commentId) {
                        var refreshedImages = []
                        c.images.map(i => {
                            if (i.fileName != fileName) {
                                refreshedImages.push(i)
                            }
                        })
                        c.images = refreshedImages;
                        if (c.images.length > 0 || c.body.length > 0) {
                            refreshedComments.push(c);
                        }
                    } else {
                        var refreshedReplies = [];
                        c.replies.map((r) => {
                            if (r.id == commentId) {
                                var refreshedImages = []
                                r.images.map(i => {
                                    if (i.fileName != fileName) {
                                        refreshedImages.push(i)
                                    }
                                })
                                r.images = refreshedImages;
                                if (r.images.length > 0 || r.body.length > 0) {
                                    refreshedReplies.push(r);
                                }
                            }
                            else {
                                refreshedReplies.push(r);
                            }
                        })
                        c.replies = refreshedReplies;
                        refreshedComments.push(c);
                    }
                })
               
                setComments(refreshedComments);
                setProcessing(false);
                toast.success(`Image Deleted`);
            })
            .catch(error => {
                setProcessing(false);
                toast.error(`Failed to delete image: ${error.message}`);
            });
    }

    function handleOnReact(reaction) {
        var userReaction = { reaction: reaction, userId: user.id, firstName: user.firstName, surname: user.surname, hasAvatar: user.avatarAvailable, itemId: post.id, itemType: "Post" }
        react(userReaction)
            .then(() => {
                postDetails.userReactions.users.push(userReaction);
                onPostEdited(postDetails);
            })
    }

    function handleOnUnReact() {
        unReact({ userId: user.id, itemId: post.id, itemType: "Post" })
            .then(() => {
                let reactionIndex = 0
                postDetails.userReactions.users.map((u, idx) => {
                    if (u.userId.toUpperCase() === user.id.toUpperCase()) {
                        reactionIndex = idx; 
                    }
                })
                postDetails.userReactions.users.splice(reactionIndex, 1);
                onPostEdited(postDetails);
            })
    }

    return (

        <div className="post">
            {!headless &&
                <div className="post-container">
                    {post.subjectData ?
                        <SubjectDataParser post={post} onDeletePost={onDeletePost} />
                        :
                        <React.Fragment>
                            <div className="post-header">
                                <div className="post-avatar">
                                {(user.id && user.id.toUpperCase() == post.authorId.toUpperCase()) ?
                                    <UserAvatar size="50" name={`${user.firstName} ${user.surname}`} src={user.avatarAvailable ? `${apiConfig.API_URL}user/avatar/${user.id}.png?v=${user.avatarVersion}` : ""} />
                                    :
                                    <UserAvatar size="50" name={`${post.authorFirstName} ${post.authorSurname}`} src={post.authorHasAvatar ? `${apiConfig.API_URL}user/avatar/${post.authorId}.png` : ""} />
                                }
                                </div>
                                {(user.id && user.id.toUpperCase() == post.authorId.toUpperCase()) &&
                                    <div className="post-options">
                                        <div className="dropdown">
                                            <button className="btn btn-link post-options-btn" id="dLabel" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <span className="fas fa-ellipsis-h"></span>
                                            </button>
                                            <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dLabel">
                                                <a className="dropdown-item" onClick={onEditPost} href="#">Edit</a>
                                                <a className="dropdown-item" onClick={onDeletePost} href="#">Delete</a>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className="post-details">
                                    <Link to={`/user/profile/${post.authorId}`}>{`${post.authorFirstName} ${post.authorSurname}`}</Link>
                                    {(post.groupName && !post.eventName) &&
                                        <React.Fragment>
                                            <span> posted in </span>
                                            <Link to={`/groups/${post.groupId}`}>{post.groupName}</Link>
                                        </React.Fragment>
                                    }
                                    {(post.eventName) &&
                                        <React.Fragment>
                                            <span> posted in the event </span>
                                            <Link to={`/events/${post.eventId}`}>{post.eventName}</Link>
                                        </React.Fragment>
                                    }
                                    <div><small className="text-muted">{`Posted: ${moment(post.postedOn).format("DD MMMM")} at ${moment(post.postedOn).format("h:mm a")}`}</small></div>
                                </div>
                            </div>

                            <div className={post.body.length > 100 ? "post-body md" : "post-body lg"}>
                                <BodyParser postId={post.id} body={post.body} showPreview={false} />
                            </div>
                            {post.images.length === 1 &&
                                <div className="post-images">
                                    <div className="carousel">
                                        <img src={`${apiConfig.API_URL}postcomment/postimage/${post.id}/${post.images[0].fileName}`} className="d-block w-100" alt="..." onClick={() => { openLightbox(0) }} />
                                    </div>
                                </div>
                            }
                            {post.images.length > 1 &&
                                <div className="post-images">
                                    <div id={`post-carousel-${post.id}`} className="carousel slide" data-ride="carousel" data-interval="false">
                                        <ol className="carousel-indicators">
                                            {post.images.map((image, idx) => {
                                                return (
                                                    <li key={`indicators-${post.id}-${idx}`} data-target={`#post-carousel-${post.id}`} data-slide-to={idx} className={idx == 0 ? "active" : ""}></li>
                                                )
                                            })}
                                        </ol>
                                        <div className="carousel-inner">
                                            {post.images.map((image, idx) => {
                                                return (
                                                    <div key={`image-${post.id}-${idx}`} className={idx == 0 ? "carousel-item active" : "carousel-item"} >
                                                        <img src={`${apiConfig.API_URL}postcomment/postimage/${post.id}/${image.fileName}`} className="d-block w-100" alt="..." onClick={() => { openLightbox(idx) }} />
                                                    </div>
                                                )
                                            })}
                                        </div>
                                        <a className="carousel-control-prev" href={`#post-carousel-${post.id}`} role="button" data-slide="prev">
                                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                            <span className="sr-only">Previous</span>
                                        </a>
                                        <a className="carousel-control-next" href={`#post-carousel-${post.id}`} role="button" data-slide="next">
                                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                            <span className="sr-only">Next</span>
                                        </a>
                                    </div>
                                </div>
                            }
                        </React.Fragment>
                    }
                    <div className="post-footer">
                        <div className="post-reaction">
                            <Reaction userReactions={post.userReactions} user={user} onReact={handleOnReact} onUnReact={handleOnUnReact} />
                        </div>
                        <div className="post-comments-status">
                            <button className="btn btn-link btn-sm" onClick={loadCommentsPanel} >
                                {processing && < span className="post-comments-loading spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
                                <span className="ml-1" >{post.commentCount > 0 ? `${post.commentCount} Comment${post.commentCount > 1 ? "s" : ""}` : "Leave a comment..."}</span>
                            </button>
                        </div>
                    </div>
                </div>
            }

            <div id={`comments-${post.id}`} className="collapse">
                <div id={`comment-feed-mask-${post.id}`} className="comment-feed-mask" style={{display: "none"}}></div>
                <CommentFeedControl comments={comments} onReplyToComment={handleReplyToComment} onEditComment={handleEditComment} onEditCommentReply={handleEditCommentReply} onDeleteComment={handleDeleteComment} onDeleteCommentReply={handleDeleteCommentReply} onDeleteCommentImage={handleDeleteCommentImage} active={active} headless={headless}/>
                {processing &&
                    <div className="post-comments-saving-status">
                        <span className="post-comments-saving spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        <span> Saving...</span>
                    </div>
                }
                {active &&
                    <div className="comments-form">
                        <PostForm post={commentDetails} user={user} placeholder="Leave a comment..." saveButtonText="Comment" onSave={onCommentSave} onChange={onCommentChange} onImagesChange={handleCommentImagesChange} saving={processing} />
                    </div>
                }
            </div>
            <div className="comment-reply-modal modal fade" id={`commentReply-${post.id}`} data-backdrop={headless && "static"} tabIndex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <img className="modal-logo" src="/resources/images/roundel.png" alt="" />
                            <h5 className="modal-title">Reply to comment</h5>
                            <button type="button" className="close" onClick={onCloseCommentReplyModal} aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <PostForm post={commentReplyDetails} user={user} placeholder="Reply..." saveButtonText="Reply" alwaysShowSubmit={true} onSave={onCommentReplySave} onChange={onCommentReplyChange} onImagesChange={handleReplyImagesChange} errors={errors} saving={processing}/>
                    </div>
                </div>
            </div>
            <div className="comment-reply-modal modal fade" id={`editPost-${post.id}`} tabIndex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <img className="modal-logo" src="/resources/images/roundel.png" alt="" />
                            <h5 className="modal-title" >Edit Post</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <PostForm post={postDetails} user={user} placeholder="Enter some text..." saveButtonText="Save" alwaysShowSubmit={true} onSave={handleEditPost} onChange={onPostEditChange} onImagesChange={handleEditPostImagesChange} saving={processing}/>
                    </div>
                </div>
            </div>
            <div className="modal fade" id={`confirmDeletePost-${post.id}`} tabIndex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <img className="modal-logo" src="/resources/images/roundel.png" alt="" />
                            <h5 className="modal-title" >Delete Post?</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            Are you sure that you want to permanently delete this post and all associated comments?
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-link" data-dismiss="modal">No</button>
                            <button type="button" className="btn btn-info" onClick={handleDeletePost}>Yes</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id={`confirmDeleteImage-${post.id}`} tabIndex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <img className="modal-logo" src="/resources/images/roundel.png" alt="" />
                            <h5 className="modal-title" >Delete Image?</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            Are you sure that you want to delete this image?
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-link" onClick={onCancelDeleteImage}>No</button>
                            <button type="button" className="btn btn-info" onClick={handleDeleteImage}>Yes</button>
                        </div>
                    </div>
                </div>
            </div>
            {post.images.length > 0 &&
                <div className="lightbox-modal modal fade" id={`post-lightbox-${post.id}`} tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-xl  modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                {(user.id && user.id.toUpperCase() == post.authorId.toUpperCase()) ?
                                    <UserAvatar size="35" name={`${user.firstName} ${user.surname}`} src={user.avatarAvailable ? `${apiConfig.API_URL}user/avatar/${user.id}.png?v=${user.avatarVersion}` : ""} />
                                    :
                                    <UserAvatar size="35" name={`${post.authorFirstName} ${post.authorSurname}`} src={post.authorHasAvatar ? `${apiConfig.API_URL}user/avatar/${post.authorId}.png` : ""} />
                                }
                                <div className="ml-2 mt-1">
                                    <span className="muted">Posted by <Link onClick={() => { $(`#post-lightbox-${post.id}`).modal("hide");}} to={`/user/profile/${post.authorId}`}>{`${post.authorFirstName} ${post.authorSurname}`}</Link> { moment(post.postedOn).fromNow() }</span>  
                                </div>
                                {(user.id && user.id.toUpperCase() == post.authorId.toUpperCase()) &&
                                    <div className="carousel-options">
                                        <div className="dropdown dropright">
                                        <button className="btn btn-link carousel-options-btn" id="dLabel" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <span className="fas fa-ellipsis-h"></span>
                                            </button>
                                            <div className="dropdown-menu" aria-labelledby="dLabel">
                                                <a className="dropdown-item" onClick={onDeleteImage} href="#">Delete</a>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                {post.images.length === 1 &&
                                    <div className="post-images">
                                        <div className="carousel">
                                            <div className="carousel-inner">
                                                <div className="post-carousel-lightbox-image-container ">
                                                    <img src={`${apiConfig.API_URL}postcomment/postimage/${post.id}/${post.images[0].fileName}`} className="post-carousel-lightbox-image" alt="..." />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {post.images.length > 1 &&
                                    <div className="post-images">
                                        <div id={`post-carousel-lightbox-${post.id}`} className="carousel slide" data-ride="carousel" data-interval="false">
                                            <ol className="carousel-indicators">
                                                {post.images.map((image, idx) => {
                                                    return (
                                                        <li key={`indicators-lightbox-${post.id}-${idx}`} data-target={`#post-carousel-lightbox-${post.id}`} data-slide-to={idx} className={idx == 0 ? "active" : ""}></li>
                                                    )
                                                })}
                                            </ol>
                                            <div className="carousel-inner">
                                                {post.images.map((image, idx) => {
                                                    return (
                                                        <div key={`image-${post.id}-${idx}`} className={idx == 0 ? "post-carousel-lightbox-image-container carousel-item active" : "post-carousel-lightbox-image-container  carousel-item"} >
                                                            <img src={`${apiConfig.API_URL}postcomment/postimage/${post.id}/${image.fileName}`} className="post-carousel-lightbox-image" alt="..." />
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                            <a className="carousel-control-prev" href={`#post-carousel-lightbox-${post.id}`} role="button" data-slide="prev">
                                                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                                <span className="sr-only">Previous</span>
                                            </a>
                                            <a className="carousel-control-next" href={`#post-carousel-lightbox-${post.id}`} role="button" data-slide="next">
                                                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                                <span className="sr-only">Next</span>
                                            </a>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    );

}

PostControl.propTypes =
{
    user: PropTypes.object.isRequired,
    post: PropTypes.object.isRequired,
    active: PropTypes.bool,
    headless: PropTypes.bool,
    expandComments: PropTypes.bool,
    onPostEdited: PropTypes.func.isRequired,
    onPostDeleted: PropTypes.func.isRequired,
    loadPostComments: PropTypes.func.isRequired,
    editPost: PropTypes.func.isRequired,
    deletePost: PropTypes.func.isRequired,
    addComment: PropTypes.func.isRequired,
    editComment: PropTypes.func.isRequired,
    deleteComment: PropTypes.func.isRequired,
    deletePostImage: PropTypes.func.isRequired,
    deleteCommentImage: PropTypes.func.isRequired,
    react: PropTypes.func.isRequired,
    unReact: PropTypes.func.isRequired,
    onCommentCountChanged: PropTypes.func,
    errorMessage: PropTypes.string
}

function mapStateToProps(state) {
    return {
        user: state.user
    };
}

const mapDispatchToProps = {
    loadPostComments,
    editPost,
    deletePost,
    addComment,
    editComment,
    deleteComment,
    deletePostImage,
    deleteCommentImage,
    react,
    unReact,
}

export default connect(mapStateToProps, mapDispatchToProps)(PostControl); 


// WEBPACK FOOTER //
// ./src/components/postComments/PostControl.js